import React, { createContext, useState, useContext } from "react";

const PayloadContext = createContext(false);

export const usePayload = () => {
  const context = useContext(PayloadContext);
  if (!context) {
    throw new Error("usePayload must be used within a LoadingProvider");
  }
  return context;
};

export const PayloadProvider = ({ children }) => {
  const onFormChange = (e) => {
    const { name, value } = e.target;

    setPayload((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const reset = () => {
    setPayload({});
  };

  const [payload, setPayload] = useState({});

  return (
    <PayloadContext.Provider
      value={{ payload, setPayload, onFormChange, reset }}
    >
      {children}
    </PayloadContext.Provider>
  );
};
